import api from '../../services/api.js'

const state = {
  pendingAnnouncementsCount: 0,
  pendingTasksCount: 0,
};

const getters = {
  pendingAnnouncementsCount: state => state.pendingAnnouncementsCount,
  pendingTasksCount: state => state.pendingTasksCount,
};

const mutations = {
  SET_PENDING_ANNOUNCEMENTS_COUNT(state, count) {
    state.pendingAnnouncementsCount = count;
  },

  SET_PENDING_TASKS_COUNT(state, count) {
    state.pendingTasksCount = count;
  },
};

const actions = {
  fetchPendingAnnouncementsCount({commit}) {
    api.get('/venteLot/').then(response => {
      const venteLots = response.data;
      const pendingCount = venteLots.filter(lot => lot.statut === "A_VALIDER").length;
      commit('SET_PENDING_ANNOUNCEMENTS_COUNT', pendingCount);
    });
  },

  fetchPendingTasksCount({commit}) {
    api.get('/operation/getAllAuthorizedOperationsByStatus').then(response => {
      const operationsData = response.data;

      let pendingCount = 0;

      operationsData.forEach(statusGroup => {
        if (statusGroup.status.value === "ONGOING" || statusGroup.status.value === "COMING") {
          statusGroup.operations.forEach(operation => {
            pendingCount += operation.nbTasks;
          });
        }
      });

      commit('SET_PENDING_TASKS_COUNT', pendingCount);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/store.js